import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [processing, setProcessing] = useState(true);
  const isTopup = searchParams.get('type') === 'topup';

  useEffect(() => {
    // Show processing message for 3 seconds
    const timer = setTimeout(() => {
      setProcessing(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (processing) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-muted/30">
        <Card className="max-w-md w-full p-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          </div>
          <h1 className="text-2xl font-bold mb-2">Processing Payment...</h1>
          <p className="text-muted-foreground">
            Please wait while we confirm your payment.
          </p>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-muted/30 p-4">
      <Card className="max-w-md w-full p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-green-100 dark:bg-green-900/20 rounded-full p-3">
            <CheckCircle className="h-12 w-12 text-green-600 dark:text-green-400" />
          </div>
        </div>
        
        <h1 className="text-3xl font-bold mb-4">Payment Successful!</h1>
        
        <p className="text-muted-foreground mb-6">
          {isTopup 
            ? "Your credits have been added to your account."
            : "Your subscription has been activated successfully."}
        </p>

        <div className="bg-muted/50 rounded-lg p-4 mb-6">
          <p className="text-sm">
            You will receive a confirmation email shortly with all the details.
          </p>
        </div>

        <Button 
          onClick={() => navigate('/settings')}
          className="w-full"
        >
          Back to Settings
        </Button>
      </Card>
    </div>
  );
};

export default PaymentSuccess;
